import React from "react";
import DealerLocatorForm from "@components/DealerLocator/DealerLocatorForm";
import { PageLayout } from "@features/shared";
import { usePageInitialization } from "@features/shared/hooks/usePageInitialization";

/**
 * DealerLocator Page
 * Find and locate dealers on map
 */
const DealerLocatorPage = () => {
  usePageInitialization();

  return (
    <PageLayout title="Dealer Locator" backPath="/">
      <DealerLocatorForm />
    </PageLayout>
  );
};

export default DealerLocatorPage;
